module.exports = __webpack_public_path__ + "img/logo.eb1738b5.svg";